module.exports = __webpack_public_path__ + "static/img/cql.54892742.png";